import React, {ReactNode, useState} from 'react'
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined'
import {Button, Stack, TextField} from '@mui/material'
import {useLocation, useNavigate} from 'react-router-dom'
import LoginGuard from 'routes/LoginGuard'
import kc from 'web-common/services/auth'
import {t} from 'i18next'

interface AssistantSearchProps {
  placeholder?: string
  label?: ReactNode
  compact?: boolean
}

const AssistantSearch = ({
  placeholder,
  label,
  compact
}: AssistantSearchProps) => {
  const [query, setQuery] = useState('')
  const navigate = useNavigate()
  const location = useLocation()

  const openChatAssistant = async (): Promise<void> => {
    let path = '/chat'
    const hasPermission = await LoginGuard.hasPermission()

    if (!hasPermission) {
      const fallbackUrl = LoginGuard.getFallbackUrl(location)

      if (fallbackUrl === '/login') {
        await kc.automaticLoginFlow(window.location.origin + path)
        return
      } else {
        path = fallbackUrl
      }
    }

    navigate(path, {
      state: {
        message: query
      }
    })
  }

  const navigateToChatAssistant = () => {
    if (query !== '') {
      openChatAssistant()
    }
  }

  const handleChatAssistantSearch = () => {
    navigateToChatAssistant()
  }

  const handleEnterKeyPress = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === 'Enter') {
      navigateToChatAssistant()
    }
  }

  return (
    <Stack direction="row" spacing={1}>
      <TextField
        label={label ?? ''}
        placeholder={
          placeholder ?? t('common:fnd-common-placeholder-search-service')
        }
        variant="outlined"
        size={compact ? 'small' : 'medium'}
        fullWidth={true}
        value={query}
        InputProps={{style: {background: 'white'}}}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={handleEnterKeyPress}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleChatAssistantSearch}
      >
        <SmartToyOutlinedIcon fontSize={compact ? 'small' : 'medium'} />
      </Button>
    </Stack>
  )
}

export default AssistantSearch
